import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-24 md:py-32 bg-background-50 relative">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(var(--foreground-500)) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="w-full px-6 md:px-10 relative z-10">
        {/* Header */}
        <div className="mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Browse Our
            <br />
            Product Categories
          </h2>
          <p className="mt-4 text-foreground-600 text-base max-w-xl">
            Explore our complete catalog — every category links directly to live product listings.
          </p>
        </div>

        {/* Grid: 3 columns, 5 rows (3+3+3+3+2) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group block rounded-3xl bg-white border border-secondary-200 overflow-hidden hover:bg-secondary-50 transition-all duration-300 cursor-pointer`}
            >
              {/* Image area - 70% height */}
              <div className="relative h-52 bg-background-100 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Text area - 30% */}
              <div className="px-5 py-4">
                <h3 className="text-lg font-semibold text-foreground-900">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 mt-1 group-hover:text-foreground-700 transition-colors duration-200">
                  Explore <span className="group-hover:translate-x-1 inline-block transition-transform duration-200">→</span>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}